import React from 'react';
import { Box, Typography } from '@mui/material';

// Shared empty state for dashboard pages whose data isn't available
const UnavailableCard = ({
  badge = "No data yet",
  title,
  message,
  image,
}) => {
  return (
    <Box sx={{
      display: "flex",
      flexDirection: { xs: "column-reverse", md: "row" },
      alignItems: "center",
      justifyContent: "center",
      gap: { xs: 2, md: 6 },
      minHeight: 420,
      p: { xs: 3, md: 6 },
      backgroundColor: "var(--c-surface)",
      border: "1px solid var(--c-border)",
      borderRadius: "16px",
    }}>
      {/* Text box */}
      <Box sx={{ maxWidth: 420, textAlign: { xs: "center", md: "left" } }}>
        <Typography sx={{
          display: "inline-block",
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "var(--c-warning)",
          backgroundColor: "var(--c-warning-bg)",
          borderRadius: "999px",
          px: 1.25,
          py: 0.5,
          mb: 2,
        }}>
          {badge}
        </Typography>

        <Typography sx={{
          fontWeight: 700,
          fontSize: 26,
          lineHeight: 1.25,
          color: "var(--c-text)",
          mb: 1,
        }}>
          {title}
        </Typography>

        <Typography sx={{
          fontSize: 15,
          lineHeight: 1.6,
          color: "var(--c-text-3)",
        }}>
          {message}
        </Typography>
      </Box>

      {/* Animation box */}
      {image && (
        <Box
          component="img"
          src={image}
          alt=""
          sx={{ maxWidth: { xs: 240, md: 320 }, width: "100%" }}
        />
      )}
    </Box>
  )
}

export default UnavailableCard;
